import { useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";

import wordmarkLight from "@/assets/adapted-wordmark-light.webp.asset.json";


export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Product", to: "/product" },
  { label: "Connected Portals", to: "/connected-portals" },
  { label: "Past Papers", to: "/past-papers" },
  { label: "About", to: "/about" },
  { label: "Meet our Team", to: "/team" },
  { label: "Contact", to: "/contact" },
] as const;

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="absolute inset-x-0 top-0 z-[70]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-6">
        <Link to="/" className="inline-flex items-center">
          <img src={wordmarkLight.url} alt="adaptED" width={600} height={147} className="h-9 w-auto" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {navLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeOptions={{ exact: item.to === "/" }}
              activeProps={{ className: "text-ink-foreground" }}
              inactiveProps={{ className: "text-ink-foreground/80" }}
              className="text-sm font-medium transition-colors hover:text-ink-foreground"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link

            to="/join-the-pilot"
            hash="contact"
            className="hidden rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-[var(--shadow-glow)] transition-transform hover:-translate-y-0.5 sm:inline-flex"
          >
            Nominate your school for 2027
          </Link>
          <button
            type="button"
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full border border-ink-foreground/20 p-2 text-ink-foreground lg:hidden"
          >
            {open ? <X className="size-5" /> : <Menu className="size-5" />}
          </button>
        </div>
      </div>

      {open
        ? createPortal(
            <nav
              id="mobile-nav"
              aria-label="Main navigation"
              className="fixed inset-x-6 top-[88px] bottom-0 z-[60] overflow-y-auto rounded-2xl border-b-0 border-ink-foreground/10 bg-ink/95 p-4 backdrop-blur lg:hidden"
            >
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className="flex min-h-11 items-center rounded-lg px-3 py-2 text-sm font-medium text-ink-foreground/80"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/join-the-pilot"
                hash="contact"
                onClick={() => setOpen(false)}
                className="mt-2 flex min-h-11 items-center rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground"
              >
                Nominate your school for 2027
              </Link>
            </nav>,
            document.body
          )
        : null}
    </header>
  );
}
